import React from 'react';
import { Helmet } from 'react-helmet-async'; // for SEO tags
import Stats from '../../../components/Global/BannerCard/Stats/Stats';
import LIRC from '../../../components/Global/BannerCard/LIRC/LIRC';
import ExpertiseSection from '../../../components/Global/BannerCard/Expertise/ExpertiseSection';
import THC from '../../../components/Global/BannerCard/T&HC/THC';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import CyientGrid from '../../../components/Global/BannerCard/CyientGrid/CyientGrid';
import CyientShowcase from '../../../components/Global/BannerCard/CyientShowcase/CyientShowcase';
import ContactPage from '../../../components/Global/BannerCard/DynamicHeader/ContactPage1';
import PartnerCarousel from '../../../components/Global/BannerCard/PartnerCarousel/PartnerCarousel';
import AwardsCarousel from '../../../components/Global/BannerCard/AwardsCarousel/AwardsCarousel';

const RailTransportation = () => {
  const canonicalUrl = `${process.env.REACT_APP_BASE_URL || 'https://www.adithyainfinity.com'}/rail-transportation`;

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>
          Rail Transportation Services | Intelligent Engineering Solutions | V Adithya Infinity Pvt Ltd
        </title>
        <meta
          name="description"
          content="Leading intelligent engineering and manufacturing solutions for Rail Transportation services. Discover sustainable innovation and advanced rail technologies."
        />
        <meta
          name="keywords"
          content="rail transportation, engineering solutions, manufacturing, rail technology, intelligent engineering, V Adithya Infinity"
        />
        <link rel="canonical" href={canonicalUrl} />

        
        <meta property="og:title" content="Rail Transportation Services | Intelligent Engineering Solutions | V Adithya Infinity Pvt Ltd" />
        <meta
          property="og:description"
          content="Leading intelligent engineering and manufacturing solutions for Rail Transportation services."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content="https://www.adithyainfinity.com/assets/images/rail-transportation-banner.jpg"
        />

        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Rail Transportation Services | Intelligent Engineering Solutions | V Adithya Infinity Pvt Ltd" />
        <meta
          name="twitter:description"
          content="Leading intelligent engineering and manufacturing solutions for Rail Transportation services."
        />
        <meta
          name="twitter:image"
          content="https://www.adithyainfinity.com/assets/images/rail-transportation-banner.jpg"
        />
      </Helmet>

      <div>
        <ContactPage
          title="LEADING WITH INTELLIGENT ENGINEERING IN RAIL TRANSPORTATION SERVICES"
          subTitle="Delivering intelligent engineering and manufacturing solutions."
          backgroundImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw8NDw0NDQ0QDQ0NEBINDQ0NEBANDQ0NFRIWFhURFRUYHSggGBolGxUVITEhJSkrOi4uFx8/OD84Nyg5OisBCgoKDg0NFQ0NFSsZFRkrLS03LSsrKy03Ny0rKystLS03LS0rNy0tLS0tNysrLTc3Ny0tNystKy03Ny0tKy0tK//AABEIAKgBLAMBIgACEQEDEQH/xAAYAAEBAQEBAAAAAAAAAAAAAAAAAQIHA//EACYQAQAABQUAAgMBAQEAAAAAAAADMdHh8AIUQVOSARFRYcGhsSH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOIAKKACoAigApZFsAAC3LJfktyC3Vm/LWTAuJfkr+QU+/8Av8TJrX8/oEVMmZMD7/gnxn/pkwLFyxcAABAARUAAFQBAAAAUURQAMmCiZMyYirbhMmW5BS3Bky3IBbgyZbkFvwJflcmBklyTOTWv5AyS1/jOTWv5/QGSEyZkwW3CZItyZMC3BfgtyX5AQyZkwATJgqGTBT5D5QABABAUAFEVQABRARSwW5BSxk0tyCljJluQLr9pfkyYH2qZMyYC5/iZMyf6ADJmTAsFuTJgWLluUvyCoZMyYAICoAoCIAAAICgAAAoCioAKBbkQWyZMyYKJk1yYFxL8rkwBMmuTAM/xMmuTAEya5MCwmTMmC5JDJmTADJgCAKAAICAACAAoAAAKIKKAClkAUQEUEBbqyoKIAKgAqAAAAgCoAoAAIAAIAIAioDQn2AoCgAgogCgKKgAomTAFQEUTJgKIuTAEyagCAAZMFAAEVEFQFAABPtUQQABftAGkAFAAABRAFEUAD7UFQAVAAABUAAAAQFQAAEAEBU+w+wPtAAAAABfg+EX4BRPgBRBRQEBUFFEEFEFFEEFEFFEEFEAAAAAAQFD7T7A+flFQAAAAAAAAFEAVWVBRFAAAAAAAAAAAAAAAAABAVBAUQAAAAABAURQAAAAAAFQBVZUFEAURfkARQBFAE+AFEAAAEAFQAAAAAAQAAHvs4vTE8aqGzi9MTxqoAGzi9MTxqouzi9MTxqogC7OL1RPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vVE8aqGzi9UTxqoAGzi9UTxqobOL1RPGqgAbOL1RPGqhs4vVE8aqABs4vTE8aqGzi9MTxqoAGzi9MTxqobOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9UTxqogC7OL1RPGqibOL0xPGqgAbOL0xPGqhs4vTE8aqABs4vTE8aqGzi9MTxqoAP/9k="
          highlightWord="RAIL TRANSPORTATION"
        />
        <Stats />
        <LIRC />
        <CyientShowcase />
        <PartnerCarousel />
        <CyientGrid />
        <ExpertiseSection />
        <THC />
        <AwardsCarousel />
        <MakeTheShift />
      </div>
    </>
  );
};

export default RailTransportation;
